import {
  IS_SEND_CODE,
  IS_VERIFIED_AUTH,
  IS_VERIFIED_TYPE,
  SESSION_USER,
  USER_TOKEN_TYPE,
} from "./../constants/login.constants";
import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import Cookies from "cookies-ts";
import { useDispatch } from "react-redux";
import { cookiesStorage } from "shared/helpers/cookiesStorage";

const cookies = new Cookies();

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = cookiesStorage.get(USER_TOKEN_TYPE)
      ? cookiesStorage.get(USER_TOKEN_TYPE)
      : cookies.get(USER_TOKEN_TYPE);
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
  cache: "no-cache",
  fetchFn(input: any, init: any) {
    return fetch(input, init).then((response: any) => {
      if (response.status === 401 && !response?.url.includes("check-setup-mode")) {
        cookiesStorage.remove(USER_TOKEN_TYPE);

        cookiesStorage.remove(USER_TOKEN_TYPE);
        cookiesStorage.remove(IS_SEND_CODE);
        cookiesStorage.remove("permissions");
        cookiesStorage.remove(IS_VERIFIED_TYPE);
        cookiesStorage.remove(IS_VERIFIED_AUTH);

        sessionStorage.removeItem(SESSION_USER);
        if (process.env.REACT_APP_SUB_PATH) {
          window.location.href = `${process.env.REACT_APP_SUB_PATH}`;
        } else {
          window.location.href = `/`;
        }
      }
      return response;
    });
  },
});

export const baseQueryWithoutToken = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}`,
});

export const baseQueryWithReAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  // if (result.error && (result.error.status === 401 || result.error.status === 403)) {
  //   window.location.href = "/";
  // }
  return result;
};
